'use strict';
import React, { Component } from 'react';

class FooterBase extends Component {
    constructor(props) {
        super(props);
    }
}

module.exports = FooterBase;